import React from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import { Input } from "../../../../stories/Input/Input";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import classes from "./SearchResultsModal.module.css";

const SearchResultsModal = ({ show, setShow }) => {
  <style>
    {`
.modal-header{
  border-bottom:0 !important;
}

`}
  </style>;
  return (
    <ModalSkeleton
      borderLine={false}
      show={show}
      setShow={setShow}
      width={"328px"}
      borderRadius={"20px"}
      modalClass={classes.body}
      headerClass={classes.header}
      header={
        <h4
          style={{
            fontFamily: "Sequel_100 Wide W05_65",
            fontSize: "26px",
            lineHeight: "36px",
          }}
        >
          Save Filter
        </h4>
      }
      footer={
        <div className={classes.footerBtns}>
          <Button
            label={"Cancel"}
            primary={false}
            customStyle={{
              width: "95px",
              marginRight: "20px",
              backgroundColor: Colors.white,
              border: "none",
              ...Fonts.b2,
              lineHeight: "20px",
            }}
            onClick={() => {
              setShow(false);
            }}
          />
          <Button
            label={"Submit"}
            primary={true}
            customStyle={{
              width: "120px",
              height: "48px",
              ...Fonts.b2,
              lineHeight: "20px",
            }}
            onClick={() => {
              // setConfirm(true);
              setShow(false);
            }}
          />
        </div>
      }
    >
      <div className={classes.input_width}>
        <Input placeholder={"Filter name"} />
      </div>
    </ModalSkeleton>
  );
};

export default SearchResultsModal;
